<template lang="pug">
#signup
    router-link(to="/")
        img(src="@/assets/img/logo/symbol-logo.png" alt="Skapi Logo" style="width: 40px; margin-bottom: .625rem")

    .page-title Sign Up

    hr

    form(@submit.prevent="signup" style='padding-bottom: 0;')        
        label
            | Email
            input.block(type="email" 
            :value='form.email' 
            @input="e=> { form.email = e.target.value; }"
            placeholder="your@email.com" 
            required)

        label
            | Name
            input.block(type="text"
            :value='form.name'
            @input="e=> { form.name = e.target.value; }"
            :placeholder="randomNamePlaceholder"
            required)


        label.passwordInput
            | Create Password
            input.block(:type='showPassword ? "text" : "password"'
            ref="passwordField" 
            @input="e=> { form.password = e.target.value; e.target.setCustomValidity(''); error = '' }"
            minlength="6"
            maxlength="60"
            placeholder="At least 6 characters" 
            required)
            //- .passwordIcon(@click="showPassword = !showPassword")
            //-     template(v-if="showPassword")
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-fill")
            //-     template(v-else)
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-off-fill")

        label.passwordInput
            | Confirm password
            input.block(:type='showPassword ? "text" : "password"'
            ref="confirmPasswordField" 
            @input="e=> { form.password_confirm = e.target.value; e.target.setCustomValidity(''); error = '' }"
            @change="validatePassword"
            placeholder="Enter your password again to confirm" 
            required)
            //- .passwordIcon(@click="showPassword = !showPassword")
            //-     template(v-if="showPassword")
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-fill")
            //-     template(v-else)
            //-         svg.svgIcon(style="fill: var(--black-6)")
            //-             use(xlink:href="/material-icon.svg?v=20250829065753667#icon-visibility-off-fill")

        .actions 
            Checkbox(v-model="form.subscribe" style='font-weight:unset;') I agree to receive newsletters from Skapi.

        br

        .error(v-if="openIdLoginError || error")
            svg
                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-error")
            span {{ openIdLoginError || error }}
        
        br

        .bottom
            div(v-if="promiseRunning" style="width:100%; text-align:center")
                .loader(style="--loader-color:white; --loader-size:12px")

            template(v-else)
                button.inline(data-track="signup_signup") Sign-up
                .signup 
                    | Have an account?&nbsp;
                    template(v-if="route.query.action")
                        RouterLink(data-track="signup_login" :to="{ name: 'login', query: { action: route.query.action } }") Login
                    template(v-else-if="route.query.refer")
                        RouterLink(data-track="signup_login" :to="{ name: 'login', query: { refer: route.query.refer } }") Login
                    template(v-else)
                        RouterLink(data-track="signup_login" :to="{name: 'login'}") Login
                    //- RouterLink(:to="route.query.suc_redirect ? {name: 'login', query: { suc_redirect: route.query.suc_redirect }} : {name: 'login'}") Login

    .or-divider
        .or-line
        .or-text OR
        .or-line

    button.gsi-material-button(style="width:440px" data-track="signup_googleLogin" @click="e=>googleLogin(e,'signup_googleLogin')")
        .gsi-material-button-state
        .gsi-material-button-content-wrapper
            .gsi-material-button-icon
                svg(version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;")
                    path(fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z")
                    path(fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z")
                    path(fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z")
                    path(fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z")
                    path(fill="none" d="M0 0h48v48H0z")
            span.gsi-material-button-contents Continue with Google
            span(style="display: none;") Continue with Google

</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { skapi, openIdLoginError } from "@/main";
import { SkapiError } from "skapi-js";
import { user } from "@/code/user";
import { onMounted, ref } from "vue";
import Checkbox from "@/components/checkbox.vue";
import { googleLogin } from "@/code/user";

const router = useRouter();
const route = useRoute();

let showPassword = ref(false);
let promiseRunning = ref(false);
let passwordField = ref(null);
let confirmPasswordField = ref(null);
let error = ref(null);
let form = ref({
    email: "",
    name: "",
    password: "",
    password_confirm: "",
    subscribe: true,
});
let routeQuery = route.query;
let randomNamePlaceholder = (() => {
    const names = [
        "Ada Lovelace",
        "Grace Hopper",
        "Jean Jennings Bartik",
        "Dennis Ritchie",
        "Niklaus Wirth"
    ];
    return names[Math.floor(Math.random() * names.length)];
})();

let validatePassword = () => {
    if (form.value.password_confirm !== form.value.password) {
        if (confirmPasswordField.value) {
            confirmPasswordField.value.setCustomValidity("Password does not match");
            confirmPasswordField.value.reportValidity();
        }
    }
};

let signup = (e) => {
    error.value = "";
    promiseRunning.value = true;

    let miscValue = {
        affiliate_signup: null,
        refer: [],
    };

    if (routeQuery?.refer) {
        miscValue.affiliate_signup = routeQuery.refer;
        miscValue.refer.push(routeQuery.refer);
    }

    let params = {
        email: form.value.email,
        name: form.value.name,
        password: form.value.password,
        misc: JSON.stringify(miscValue),
    };

    let options = {
        signup_confirmation: "/success",
        email_subscription: form.value.subscribe,
    };

    if (routeQuery) {
        if (routeQuery?.refer) {
            options.signup_confirmation = "/success?refer=" + routeQuery.refer;
        } else {
            options.signup_confirmation = "/success";
        }

        if (routeQuery?.action) {
            options.signup_confirmation =
                options.signup_confirmation +
                "?action=" +
                routeQuery.action;
        }
    }

    skapi
        .signup(params, options)
        .then((res) => {
            router.push({
                path: "/confirmation",
                query: { email: form.value.email },
            });
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;

            promiseRunning.value = false;

            switch (err.code) {
                case "EXISTS":
                case "UsernameExistsException":
                    error.value = "This email is already in use";
                    break;
                default:
                    error.value =
                        "Something went wrong please contact an administrator.";
                    throw err;
            }
        });
};
</script>

<style scoped lang="less">
#signup {
    max-width: 480px;
    padding: 5rem 20px;
    margin: 0 auto;
    width: 100%;
}

form {
    padding: 8px;

    >label {
        margin-bottom: 16px;
    }

    .actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .bottom {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
        min-height: 44px;

        .signup {
            font-size: 16px;
            margin: 16px 0;
        }
    }
}

// .passwordInput {
//     position: relative;

//     .passwordIcon {
//         position: absolute;
//         right: 15px;
//         bottom: 10px;
//         opacity: 0.5;
//         cursor: pointer;
//     }
// }

@media (max-width: 480px) {
    form {
        .bottom {
            display: block;
            text-align: center;

            button {
                width: 100%;
            }

            .forgot {
                display: block;
                margin-bottom: 8px;
            }
        }
    }
}
</style>
